import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Biblioteca } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesBiblioteca, validationSchemaBiblioteca } from "./BibliotecaCommon"
import BibliotecaForm from "./BibliotecaForm"
import { useBibliotecaCreate } from "../../hooks/biblioteche"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function BibliotecaCreate() {
  const createBiblioteca = useBibliotecaCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Biblioteche", href: "/biblioteche/biblioteche" }, { label: "Creazione Biblioteca" }])

  const initialValues = useMemo(() => initialValuesBiblioteca(), [])
  const validationSchema = useMemo(() => validationSchemaBiblioteca(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova biblioteca</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createBiblioteca.mutateAsync(values as Biblioteca).then((biblioteca) => {
                navigate(`/biblioteche/biblioteche`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <BibliotecaForm />
                </Container>
                <BottomFormFixed url="/edicione/biblioteche" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
